<template>
  <div class="swag-commerce">
    <div class="header-container">
      <picture class="header-picture">
        <source media="(max-width: 767px)" srcset="https://cdn.shopify.com/s/files/1/1363/8433/files/mobile_swag_header.jpg?v=1725919435">
        <img  class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/header_ecommerce.png?v=1725037354"/>
      </picture>
      <div class="title-container">
        <p class="title">Shop Swag</p>
        <div class="instructions">
          <div>
            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/trending_swag.svg?v=1725037476"/>
            <p>Trending <br/> Swag</p>
          </div>
          <div>
            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/quality_icon_77d7aa1e-b76d-4d1a-bf41-e87458c8cf41.svg?v=1725037476"/>
            <p class="desktop">Quality <br/> brand names</p>
            <p class="mobile">Quality brands</p>
          </div>
          <div>
            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/ship_many_icon_a6aa3cc2-bf00-4ffb-895a-db7c8e8450f1.svg?v=1725037476"/>
            <p class="desktop">Ship one or many <br/> with ease</p>
            <p class="mobile">Bulk shipping</p>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-header">
      <div class="top-brands">
        <p class="title">Top Brands, <br class="mobile"/> Your Style, Your Logo</p>
        <p class="subtitle desktop">Shop swag from your favorite brands and discover trending new brands today. Don’t see what you want? <a href="https://calendar.app.google/BS3epNk6LrNPc7ca6">Talk to Sales.</a></p>
        <p class="subtitle mobile">Don’t see what you want? <a href="https://calendar.app.google/BS3epNk6LrNPc7ca6">Talk to Sales.</a></p>
      </div>
    </div>
    <div class="filters-bar">
      <div class="buttons-container">
        <button class="hb-btn secondary" :class=" totalCurrentFilters > 0 ? 'selected' : ''" @click="showFilters()">
          <img v-if="totalCurrentFilters > 0" class="purple" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"/>
          <img v-else class="normal" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"/>
          Filters 
          <span v-if="totalCurrentFilters > 0">({{ totalCurrentFilters }})</span>
        </button>
        <button class="hb-btn secondary" @click="showSort()"><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/Group_4412.png?v=1722267051"/>Sort</button>
      </div>
    </div>
    <div class="products-container">
      <div class="products-list">
        <ul class="no-scrollbar" v-if="sortedProducts && sortedProducts.length > 0">
          <li v-for="product in sortedProducts">
            <div class="product-container" @click="selectProduct(product)">
              <div class="product-image-container">
                <img class="logo-placeholder" src="https://cdn.shopify.com/s/files/1/1363/8433/files/logo_grey_2.svg?v=1725379927" alt="logo here"/>
                <img class="lazyload main-image" width="280" height="280" :src="product | getProductImage">
                <span class="secondary-badge">{{ secondaryBadge(product) }}</span>
                <div class="edit-float">
                  <p>Add your logo</p>
                  <div class="edit-btn">
                    <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634" alt="edit"/>
                  </div>
                </div>
              </div>
                <button class="hb-btn secondary" @click="selectProduct(product)">Customize Now</button>
                <p class="title">{{product.title}}</p>
                <div class="product-price-container">
                  <span v-if="product.variants.find(x => x.price != '').compare_at_price" class="discount-price">{{product.variants.find(x => x.price != '').compare_at_price | moneySaleFormat}}</span>
                  <span class="price">{{product | moneyFormat}}</span>
                </div>
            </div>
          </li>
        </ul>
        <ul v-else class="no-scrollbar">
          <li v-for="n in 12" :key="n">
            <AddonProductSkeleton/>
          </li>
        </ul>
      </div>
    </div>
    <div class="swag-solutions">
      <img class="background-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/gradient_bg.png?v=1725031842"/>
      <div class="floating-container">
        <div class="details">
          <h2 class="desktop">Unparalleled Swag Solutions</h2>
          <p>Need more support with your swag? We can help:</p>
          <ul>
            <li><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114" alt="Check">Storage & distribution</li>
            <li><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114" alt="Check">Let them pick their swag</li>
            <li><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114" alt="Check">Sizing & logistics handled</li>
            <li><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114" alt="Check">Custom swag kits</li>
            <li><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114" alt="Check">Logo boxes</li>
          </ul>
          <a href="https://calendar.app.google/BS3epNk6LrNPc7ca6" class="hb-btn primary">Book a Call</a>
        </div>
        <div class="image-container">
          <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/webfx.png?v=1724947313" class="lazyload main-image" alt="swag"/>
        </div>
        <h2 class="mobile">Unparalleled Swag Solutions</h2>
      </div>
    </div>
    <div class="bottom-section">
      <FAQ/>
    </div>
    <FiltersMobile :filteredPreAddons="filteredPreProducts" @closefilter="showFilters()" v-if="filterIsShown" :filteredAddons="sortedProducts"/>
    <SortMobile @closefilter="showSort()" v-if="sortIsShown"/>
    <BrandableModal @close="selectProduct(null)" :selectedAddon="selectedProduct" v-if="selectedProduct"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FAQ from './components/FAQ.vue'
import AddonProductSkeleton from './components/Skeletons/AddonProductSkeleton.vue'
import BrandableModal from './components/BrandableModal.vue'
import SortMobile from './components/Filters/SortMobile.vue'
import FiltersMobile from './components/Filters/FiltersMobile.vue'
require('dotenv').config();

export default {
  components:{
    FAQ,
    AddonProductSkeleton,
    BrandableModal,
    SortMobile,
    FiltersMobile
  },
  directives: {
  },
  data(){
    return{
      selectedProduct: null,
      filterIsShown: false,
      sortIsShown: false,
    }
  },
  computed:{
    ...mapGetters([
      'addonProducts',
      'selectedSort',
      'selectedCategory',
      'rangePrice',
      'categories',
    ]),
    totalCurrentFilters(){
      let total = this.selectedCategory.filter(x => x != "View All").length;
      return total
    },
    secondOccasions(){
      if(this.categories && this.categories.length)
      return this.categories.filter(x => x.title != "View All");

      return [];
    },
    filteredPreProducts() {
      let filterAddons = JSON.parse(JSON.stringify(this.addonProducts));
      //filter via occasion
      if (!this.selectedCategory.includes("View All")) {
        filterAddons = filterAddons.filter(x => x.tags.some(y => this.selectedCategory.some(z => y.includes(z))));
      }

      return filterAddons;
    },
    filteredProducts() {
      //Filter Price
      return this.filteredPreProducts.filter(x => ((x.variants[0].price - this.rangePrice.min) * (x.variants[0].price - this.rangePrice.max) <= 0));
    },
    sortedProducts(){
      var sortedProducts = JSON.parse(JSON.stringify(this.filteredProducts));
      switch(this.selectedSort){
        case "2":
          sortedProducts.sort((a,b) => {
              var aIsIncluded = a.tags.some(x => x.includes("Swag_Badges_Best Sellers"));
              var bIsIncluded = b.tags.some(x => x.includes("Swag_Badges_Best Sellers"));
              if(aIsIncluded == bIsIncluded){
                  return 0;
              }
              else if(aIsIncluded == true){
                  return -1;
              }
              else if(bIsIncluded == true){
                  return 1;
              }
          });
          break
      case "3":
          sortedProducts.sort((a,b) => {
              var aIsIncluded = this.dateDiffInDays(new Date(a.published_at),new Date()) < 60;
              var bIsIncluded = this.dateDiffInDays(new Date(b.published_at),new Date()) < 60;
              if(aIsIncluded == bIsIncluded){
                  return 0;
              }
              else if(aIsIncluded == true){
                  return -1;
              }
              else if(bIsIncluded == true){
                  return 1;
              }
          })
          break
      case "4":
          sortedProducts.sort((a,b) => { return a.variants[0].price - b.variants[0].price});
          break;
      case "5":
          sortedProducts.sort((a,b) => { return b.variants[0].price - a.variants[0].price})
          break;
      default:
          break;
      }

      return sortedProducts.filter(x => x.variants.some(y => y.available));
    },
  },
  methods:{
    showFilters(){
      this.filterIsShown = !this.filterIsShown;
    },
    showSort(){
      this.sortIsShown = !this.sortIsShown;
    },
    selectProduct(product){
      this.selectedProduct = product;
    },
    secondaryBadge(product){
      //Check badges in the following order. 
      // Minimum: has qtymin tag
      // Almost gone: Invetory < 20
      // Best seller: has "Filter_Badges_Best Seller" tag
      // New: has been published for less that 60 days

      let qtyMin = product.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND")) 
      if(qtyMin){
        qtyMin = qtyMin.split("_");
        qtyMin = qtyMin[qtyMin.length - 1];

        return `Minimum: ${qtyMin}`;
      }
  
      var badge = product.tags.find(y => y.includes("Swag_Badges"));
      if(badge){
          badge = badge.replace("Swag_","").split("_")
          return badge[1];
      }

      return null
    },
    dateDiffInDays(a, b) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      // Discard the time and time-zone information.
      const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    },
  },
  mounted() {
  },
  destroy() {
  }
}
</script>

<style scoped>

.header-container{
    width: 100%;
    display: flex;
    position: relative;
    padding-top: 5%;
    background-color: #d1b6b2;
  }

  .header-container picture{
    width: 100%;
    display: flex;
  }

  .header-container .main-image{
    width: 100%;
  }

  .title-container{
    width: 50%;
    position: absolute;
    top: 0%;
    left: 5%;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.title-container .title{
    font-size: 4.5vw;
    line-height: 0.8;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 600;
    margin: unset;
    margin-bottom: 1rem;
}

.title-container .subtitle{
  font-size: 1.3vw;
  margin-bottom: 0.5rem;
}

.title-container .instructions{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.title-container .instructions div{
    width: 26%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title-container .instructions div img{
    margin-bottom: 0.5rem;
    height: 3vw;
}

.title-container .instructions .first img{
    max-width: 50%;
}

.title-container .instructions .last img{
    padding: 2%;
}

.title-container .instructions div{
    font-size: 1.2vw;
    line-height: 1.2;
    font-weight: bold;
}

.products-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0% 10% 5%;
}

.top-brands{
  width: 100%;
  display: flex;
  gap: 2%;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid lightgray;
}

.top-brands .title{
  font-size: 3vw;
  line-height: 1;
  font-family: ff-more-web-pro-condensed;
  margin: unset;
  flex-shrink: 0;
}

.top-brands .subtitle{
  font-size: 1.15vw;
  margin: unset;
  line-height: 1.2;
}

.top-brands .subtitle > a{
  color: #A01ADB;
  text-decoration: underline;
}

.products-container .products-list{
  width: 100%;
  margin-top: 1rem;
}

.products-container .products-list ul{
  width: 100%;
  height: fit-content;
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  gap: 2.66%;
}

.products-container .products-list ul li{
  width: 23%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.products-container li .product-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.products-container li .product-container .secondary-badge{
    position: absolute;
    bottom: 2%;
    right: 2%;
    background-color: #eff4fe;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1% 3%;
    font-size: 1.1vw;
    font-weight: 700;
    color: #5981d9;
}

.products-container li .product-container .edit-float{
  position: absolute;
  top: 5%;
  right: 5%;
  display: flex;
  align-items: center;
  z-index: 2;
  cursor: pointer;
  justify-content: space-between;
  width: auto;
}

.products-container li .product-container .edit-float p{
  font-size: 1vw;
  font-weight: 700;
  text-align: center;
  line-height: 1.2;
  background-color: #5cffc0;
  padding: 0.1rem 1rem;
  flex-shrink: 0;
  border-radius: 8px;
  position: relative;
  right: -7%;
  margin: unset;
}

.products-container li .product-container .edit-btn{
  border-radius: 50%;
  background-color: #5cffc0;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  width: 25px;
  flex-shrink: 0;
  z-index: 0;
}

.products-container li .product-container .edit-btn img{
  width: 100%;
}

.products-container li .product-container .product-image-container{
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  margin-bottom: 0.5rem;
}

.products-container li .product-container .product-image-container .main-image{
  width: 100%;
  background-color: #F6F6F6;
  cursor: pointer;
  height: 100%;
  aspect-ratio: 1;
  object-fit: cover;
}

.products-container li .product-container .product-image-container .logo-placeholder{
  position: absolute;
  width: 15%;
  top: 45%;
  left: 42.5%;
}

.products-container li .product-container .title{
  font-weight: 700;
  font-size: 1.1vw;
  line-height: 1.5;
  margin-top: 2%;
  margin-bottom: 0;
}

.products-container li .product-container .product-price-container{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 1vw;
  line-height: 1.43;
  padding-bottom: 5%;
}

.products-container li .product-container .product-price-container .price{
  color: #3F3D60;
}

.products-container li .product-container .product-price-container .discount-price{
  color: red;
  text-decoration: line-through;
  padding-right: 5%;
}

.global-spinner-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.2);
  position: fixed;
  height: 100%;
  z-index: 999;
  top: 0;
}

.global-spinner-container p{
  font-size: 16px;
  color: white !important;
  font-weight: bold;
}

.global-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}

  .swag-solutions {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 0 auto;
    position: relative;
	}

  .swag-solutions .background-image{
    width: 100%;
  }

  .swag-solutions .floating-container{
    display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 5% 10% 0;
		margin: 0 auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
  }

	.swag-solutions .image-container{
		width: 50%;
		position: relative;
		display: flex;
		align-items: flex-end;
		justify-content: flex-end;
	}

  .swag-solutions .image-container .main-image{
    width: 100%;
  }
	.swag-solutions .details {
		width: 50%;
		padding-left: 10%;
		display: flex;
		flex-direction: column;
	}

  .swag-solutions h2 {
		margin-bottom: 5%;
		font-size: 4vw;
    	width: 100%;
		line-height: 1;
		font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
		font-weight: 300;
	}

	.swag-solutions h2 span {
		font-style: italic;
	}

	.swag-solutions .details ul {
		list-style: none;
		padding: 0;
		width: 100%;
		margin-bottom: 2rem;
	}

	.swag-solutions .details ul li {
		display: flex;
		align-items: center;
		font-size: 1.3vw;
		margin-bottom: unset;
	}

	.swag-solutions .details ul li img{
		margin-right: 10px;
		width: 1.3vw;
		height: auto;
	}

  .filters-bar{
    width: 100%;
    padding: 1% 10%;
    position: sticky;
    top: 90px;
    background-color: white;
    z-index: 1;
  }

  .filters-bar .buttons-container{
    display: flex;
    gap: 5%;
    flex: 1;
    width: 50%;
  }

  .filters-bar .buttons-container button{
    display: flex;
    gap: 5px;
    align-items: center;
    padding: 1% 5%;
  }

  .filters-bar .buttons-container button.selected{
    color: #a01adb;
    font-weight: 700;
    border: 1px solid #a01adb;
  }

  .filters-bar .buttons-container button.selected span{
    color: #a01adb;
    font-weight: 700;
  }

  .filters-bar .buttons-container button img{
    width: 15px;
    padding: unset
  }

  .bottom-section{
    padding: 5% 10%;
  }

  .filter-header{
    width: 100%;
    padding: 5% 10% 0%;
  }

  .filter-categories-container{
    display: none
  }

@media screen and (max-width: 767px) {

  .swag-solutions .details ul li{
    text-align: left;
    align-items: flex-start;
  }

  .swag-solutions .image-container,.swag-solutions .details{
    width: 100%;
    padding: unset;
    align-items: center;
    flex-direction: column;
    display: flex;
    text-align: center;
		}

		.swag-solutions h2{
			text-align: center;
      font-size: 8vw;
		}

		.swag-solutions .details ul{
			width: unset;
			margin-bottom: 1rem;
		}

		.swag-solutions .details ul li{
			font-size: 4vw;
			width: 100%;
		}

		.swag-solutions .details ul li img{
			width: 18px;
			margin-top: 4px;
		}

    .title-container{
    width: 50%;
    position: absolute;
    top: 0%;
    left: 0%;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.title-container .title{
    font-size: 9vw;
    line-height: 0.8;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 600;
    margin: unset;
    margin-bottom: 0.5rem;
}

.title-container .instructions{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-top: 0.5rem;
}

.title-container .instructions div{
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title-container .instructions div img{
    margin-bottom: 0.5rem;
    height: 5vw;
    max-width: 100%;
}

.title-container .instructions .first img{
    max-width: 80%;
}

.title-container .instructions div p{
    font-size: 2vw;
    line-height: 1.2;
    font-weight: bold;
}

.products-container .products-list ul li{
  width: 48%;
}
.products-container li .product-container .title,.products-container li .product-container .product-price-container{
  font-size: 1rem;
}

.top-brands{
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.5rem;
}

.top-brands .title{
  font-size: 7vw;
}

.top-brands .subtitle{
  font-size: 3.5vw;
}

.swag-solutions .floating-container{
    flex-direction: column-reverse;
    position: initial;
    background: url(https://cdn.shopify.com/s/files/1/1363/8433/files/gradient_bg.png?v=1725031842);
    background-size: 100% 100%;
    padding: 20% 10% 5%;
}

.swag-solutions .background-image{
    display: none;
}

.filter-categories-container{
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0% 2%;
        box-shadow: 0 1px #0003;
        position: sticky;
        top: 80px;
        z-index: 1;
        background-color: white;
    }

    .filter-categories-container .title{
        flex: 2;
        font-size: 3vw;
        display: flex;
        gap: 5px;
        font-weight: bold;
        align-items: center;
        margin: unset;
    }

    .filter-categories-container .title img{
        width: 15px;
    }

    .filter-categories-container .white{
        font-size: 3vw;
        flex: 2;
        padding: 0.5%;
    }

    .categories-container{
    flex: 4;
    display: flex;
    align-items: center;
    white-space: nowrap;
    padding: 2% 0%;
}

.categories-container button{
    margin: 0% 1%;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 2.5vw;
    line-height: 1.3;
    color: #7A7991;
    padding: 2%;
    border-radius: 20px;
    border: 1px solid lightgray;
}

.categories-container button.selected{
    color: white;
    background-color: #0F0C38;
}

.filters-bar{
  top: 80px;
}

.products-container li .product-container .secondary-badge{
  font-size: 1rem;
}

.products-container li .product-container .edit-float p{
    font-size: 3vw;
  }
}
</style>